import React from 'react';

import { token } from '@atlaskit/tokens';

export const CardsExtensionIcon = (): React.JSX.Element => {
	// Moving from <Icon> to <svg> since this icon will be replaced soon
	// and because of the complexity of scaling each path in the SVG.
	return (
		<svg
			width="32"
			height="22"
			viewBox="0 0 32 22"
			// TODO: Update the attribute below so it is translated.
			// eslint-disable-next-line no-restricted-syntax
			aria-label="Card"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask id="path-1-inside-1_4424_408291" fill={token('elevation.surface.raised')}>
				<path d="M8 11H24V21C24 21.5523 23.5523 22 23 22H9C8.44772 22 8 21.5523 8 21V11Z" />
			</mask>
			<path
				d="M8 11H24V21C24 21.5523 23.5523 22 23 22H9C8.44772 22 8 21.5523 8 21V11Z"
				fill={token('elevation.surface.raised')}
			/>
			<path
				d="M8 11H24H8ZM25 21C25 22.1046 24.1046 23 23 23H9C7.89543 23 7 22.1046 7 21H9H23H25ZM9 23C7.89543 23 7 22.1046 7 21V11H9V21V23ZM25 11V21C25 22.1046 24.1046 23 23 23V21V11H25Z"
				fill={token('color.background.neutral.hovered')}
				mask="url(#path-1-inside-1_4424_408291)"
			/>
			<rect
				x="11"
				y="13"
				width="10"
				height="2"
				rx="1"
				fill={token('color.background.neutral.hovered')}
			/>
			<rect
				x="11"
				y="16"
				width="10"
				height="2"
				rx="1"
				fill={token('color.background.neutral.hovered')}
			/>
			<g clipPath="url(#clip0_4424_408291)">
				<rect x="8" width="16" height="11" fill={token('color.background.neutral.hovered')} />
				<path
					d="M9.56641 9.66749L13.2958 5.53027L17.0252 9.66749H9.56641Z"
					fill={token('color.background.accent.blue.bolder')}
				/>
				<path
					d="M11.5586 9.66747L17.0239 3.60449L22.4891 9.66747H11.5586Z"
					fill={token('color.icon.information')}
				/>
				<g opacity="0.37">
					<path
						d="M18.9894 7.11779C17.2437 6.25471 15.5864 6.72991 13.31 6.17401C11.7498 5.79302 9.81297 4.90515 8 2.75V10.9403H21.5292C21.3154 9.51503 20.6897 7.95836 18.9894 7.11779Z"
						fill="url(#paint0_linear_4424_408291)"
					/>
				</g>
				<path
					d="M11.3333 4.85151C12.0697 4.85151 12.6667 4.22717 12.6667 3.457C12.6667 2.68684 12.0697 2.0625 11.3333 2.0625C10.597 2.0625 10 2.68684 10 3.457C10 4.22717 10.597 4.85151 11.3333 4.85151Z"
					fill={token('color.background.accent.orange.subtle')}
				/>
			</g>
			<rect
				x="26"
				y="19"
				width="16"
				height="11"
				transform="rotate(-90 26 19)"
				fill={token('color.background.neutral.hovered')}
			/>
			<rect
				x="6"
				y="3"
				width="16"
				height="11"
				transform="rotate(90 6 3)"
				fill={token('color.background.neutral.hovered')}
			/>
			<defs>
				<linearGradient
					id="paint0_linear_4424_408291"
					x1="21.6237"
					y1="2.12675"
					x2="6.03556"
					y2="2.12675"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor={token('color.border')} />
					<stop
						offset="0.1252"
						stopColor={token('color.background.neutral.subtle.hovered')}
						stopOpacity="0.8589"
					/>
					<stop
						offset="0.5465"
						stopColor={token('color.background.neutral.subtle.hovered')}
						stopOpacity="0.4017"
					/>
					<stop
						offset="0.8366"
						stopColor={token('color.background.neutral.subtle.hovered')}
						stopOpacity="0.1128"
					/>
					<stop
						offset="0.9703"
						stopColor={token('color.background.neutral.subtle.hovered')}
						stopOpacity="0.01"
					/>
				</linearGradient>
				<clipPath id="clip0_4424_408291">
					<path
						d="M8 1C8 0.447715 8.44772 0 9 0H23C23.5523 0 24 0.447715 24 1V11H8V1Z"
						fill={token('color.background.neutral.hovered')}
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
